module.exports = __webpack_public_path__ + "Legend.d110b00bb603253820c310312cf071e1.png";